import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/webp/success.webp'
import _imports_1 from '@/assets/webp/failed.webp'


const _withScopeId = n => (_pushScopeId("data-v-87745a60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "result" }
const _hoisted_2 = {
  key: 0,
  class: "success"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "success"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Payment Successful", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "failed"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "failed"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Payment Failed", -1))
const _hoisted_9 = ["href"]

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { getOrderResult } from "../tools/checkstand/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'Result',
  setup(__props) {

const end = ref(false);
const isSuccessed = ref(false);
const backURL = ref("");

onMounted(() => {
  const route = useRoute();
  const orderId = route.query.order;
  if (orderId) {
    getOrderResult(orderId as string)
      .then((data) => {
        if (data.returnUrl) {
          backURL.value =
            data.returnUrl + `?resultCode=${data.resultCode}&orderSn=${data.MerOrderNo}`;
        }
        isSuccessed.value = data.resultCode === "1";
      })
      .catch(() => {
        alert("Server Error");
      })
      .finally(() => {
        end.value = true;
      });
  } else {
    alert("无效地址");
    end.value = true;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_CHLoading = _resolveComponent("CHLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!end.value)
      ? (_openBlock(), _createBlock(_component_CHLoading, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (isSuccessed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                (backURL.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn",
                      href: backURL.value,
                      target: "_parent"
                    }, "Confirm", 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                (backURL.value)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn",
                      href: backURL.value,
                      target: "_parent"
                    }, "Confirm", 8, _hoisted_9))
                  : _createCommentVNode("", true)
              ]))
        ], 64))
  ]))
}
}

})